// import createjs from '../../../vendors/js/createjs.min';
import resultShareSrc from '../../../assets/images/ResultBackground.jpg';

const createjs = require('createjs/builds/1.0.0/createjs');

let AdobeAn;

(function (cjs, an, img) {

    let p; // shortcut to reference prototypes
    const lib = {}; const ss = {}; var img = {};

    lib.ssMetadata = [];

    (lib.AnMovieClip = function () {
        this.actionFrames = [];
        this.ignorePause = false;
        this.gotoAndPlay = function (positionOrLabel) {
            cjs.MovieClip.prototype.gotoAndPlay.call(this, positionOrLabel);
        };
        this.play = function () {
            cjs.MovieClip.prototype.play.call(this);
        };
        this.gotoAndStop = function (positionOrLabel) {
            cjs.MovieClip.prototype.gotoAndStop.call(this, positionOrLabel);
        };
        this.stop = function () {
            cjs.MovieClip.prototype.stop.call(this);
        };
    }).prototype = p = new cjs.MovieClip();
    // symbols:

    (lib.ResultBackground = function () {
        this.initialize(img.ResultBackground);
    }).prototype = p = new cjs.Bitmap();
    p.nominalBounds = new cjs.Rectangle(0, 0, 1200, 630);// helper functions:

    function mc_symbol_clone() {
        const clone = this._cloneProps(new this.constructor(this.mode, this.startPosition, this.loop, this.reversed));

        clone.gotoAndStop(this.currentFrame);
        clone.paused = this.paused;
        clone.framerate = this.framerate;

        return clone;
    }

    function getMCSymbolPrototype(symbol, nominalBounds, frameBounds) {
        const prototype = cjs.extend(symbol, cjs.MovieClip);

        prototype.clone = mc_symbol_clone;
        prototype.nominalBounds = nominalBounds;
        prototype.frameBounds = frameBounds;

        return prototype;
    }

    (lib.PostfixMc = function (mode, startPosition, loop, reversed) {
        if (loop == null) { loop = true; }
        if (reversed == null) { reversed = false; }
        const props = new Object();

        props.mode = mode;
        props.startPosition = startPosition;
        props.labels = {};
        props.loop = loop;
        props.reversed = reversed;
        cjs.MovieClip.apply(this, [props]);

        // Layer_2
        this.num = new cjs.Text('0', "bold 123px 'Montserrat ExtraBold'", '#FFD21D');
        this.num.name = 'num';
        this.num.textAlign = 'right';
        this.num.lineHeight = 29;
        this.num.lineWidth = 413;
        this.num.parent = this;
        this.num.setTransform(-2.3102, -69.8, 0.8636, 0.8651);

        this.timeline.addTween(cjs.Tween.get(this.num).wait(1));

        // Layer_1
        this.postfix = new cjs.Text('СНЕЖКОВ', "bold 80px 'Montserrat ExtraBold'", '#FFD21D');
        this.postfix.name = 'postfix';
        this.postfix.lineHeight = 29;
        this.postfix.lineWidth = 504;
        this.postfix.parent = this;
        this.postfix.setTransform(22.25, -42, 0.8636, 0.8651);

        this.timeline.addTween(cjs.Tween.get(this.postfix).wait(1));

        this._renderFirstFrame();

    }).prototype = getMCSymbolPrototype(lib.PostfixMc, new cjs.Rectangle(-360.9, -71.5, 820.2, 133.1), null);

    // stage content:
    (lib.share_result = function (mode, startPosition, loop, reversed) {
        if (loop == null) { loop = true; }
        if (reversed == null) { reversed = false; }
        const props = new Object();

        props.mode = mode;
        props.startPosition = startPosition;
        props.labels = {};
        props.loop = loop;
        props.reversed = reversed;
        cjs.MovieClip.apply(this, [props]);

        this.actionFrames = [0];
        this.isSingleFrame = false;
        // timeline functions:
        this.frame_0 = function () {
            if (this.isSingleFrame) {
                return;
            }
            if (this.totalFrames == 1) {
                this.isSingleFrame = true;
            }
            function numWord(value, words) {
                value = Math.abs(value) % 100;
                const num = value % 10;

                if (value > 10 && value < 20) return words[2];
                if (num > 1 && num < 5) return words[1];
                if (num == 1) return words[0];

                return words[2];
            }

            function setResult(root, value) {
                function getCenterShift(txt1, txt2) {
                    console.log(txt1.getMeasuredWidth(), txt2.getMeasuredWidth());

                    return 0.5 * (txt1.getMeasuredWidth() - txt2.getMeasuredWidth());
                }

                root.num.text = value.toString();
                root.postfix.text = numWord(value, ['снежинка', 'снежинки', 'снежинок']).toUpperCase();
                root.x = root.stage.getBounds().width * 0.5 + getCenterShift(root.num, root.postfix);
            }

            this.setResult = function (value) {
                setResult(this.numText, value);
            };
        };

        // actions tween:
        this.timeline.addTween(cjs.Tween.get(this).call(this.frame_0).wait(1));

        // numText
        this.numText = new lib.PostfixMc();
        this.numText.name = 'numText';
        this.numText.setTransform(600, 288.3);
        this.numText.shadow = new cjs.Shadow('#FFD21D', 0, 0, 16);

        this.timeline.addTween(cjs.Tween.get(this.numText).wait(1));

        // bg
        this.instance = new lib.ResultBackground();

        this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

        this._renderFirstFrame();

    }).prototype = p = new lib.AnMovieClip();
    p.nominalBounds = new cjs.Rectangle(600, 315, 600, 315);
    // library properties:
    lib.properties = {
        id: '04AF873B120D41D0B29AE1A02A4D398A',
        width: 1200,
        height: 630,
        fps: 24,
        color: '#FFFFFF',
        opacity: 1.00,
        manifest: [
            { src: 'images/ResultBackground.jpg', id: 'ResultBackground' }
        ],
        preloads: []
    };

    // bootstrap callback support:

    (lib.Stage = function (canvas) {
        createjs.Stage.call(this, canvas);
    }).prototype = p = new createjs.Stage();

    p.setAutoPlay = function (autoPlay) {
        this.tickEnabled = autoPlay;
    };
    p.play = function () { this.tickEnabled = true; this.getChildAt(0).gotoAndPlay(this.getTimelinePosition()); };
    p.stop = function (ms) { if (ms) this.seek(ms); this.tickEnabled = false; };
    p.seek = function (ms) { this.tickEnabled = true; this.getChildAt(0).gotoAndStop(lib.properties.fps * ms / 1000); };
    p.getDuration = function () { return this.getChildAt(0).totalFrames / lib.properties.fps * 1000; };

    p.getTimelinePosition = function () { return this.getChildAt(0).currentFrame / lib.properties.fps * 1000; };

    an.bootcompsLoaded = an.bootcompsLoaded || [];
    if (!an.bootstrapListeners) {
        an.bootstrapListeners = [];
    }

    an.bootstrapCallback = function (fnCallback) {
        an.bootstrapListeners.push(fnCallback);
        if (an.bootcompsLoaded.length > 0) {
            for (let i = 0; i < an.bootcompsLoaded.length; ++i) {
                fnCallback(an.bootcompsLoaded[i]);
            }
        }
    };

    an.compositions = an.compositions || {};
    an.compositions['04AF873B120D41D0B29AE1A02A4D398A'] = {
        getStage() { return exportRoot.stage; },
        getLibrary() { return lib; },
        getSpriteSheet() { return ss; },
        getImages() { return img; }
    };

    an.compositionLoaded = function (id) {
        an.bootcompsLoaded.push(id);
        for (let j = 0; j < an.bootstrapListeners.length; j++) {
            an.bootstrapListeners[j](id);
        }
    };

    an.getComposition = function (id) {
        return an.compositions[id];
    };

    an.makeResponsive = function (isResp, respDim, isScale, scaleType, domContainers) {
        let lastW; let lastH; let
            lastS = 1;

        window.addEventListener('resize', resizeCanvas);
        resizeCanvas();
        function resizeCanvas() {
            const w = lib.properties.width; const
                h = lib.properties.height;
            const iw = window.innerWidth; const
                ih = window.innerHeight;
            const pRatio = window.devicePixelRatio || 1; const xRatio = iw / w; const yRatio = ih / h; let
                sRatio = 1;

            if (isResp) {
                if ((respDim == 'width' && lastW == iw) || (respDim == 'height' && lastH == ih)) {
                    sRatio = lastS;
                } else if (!isScale) {
                    if (iw < w || ih < h) sRatio = Math.min(xRatio, yRatio);
                } else if (scaleType == 1) {
                    sRatio = Math.min(xRatio, yRatio);
                } else if (scaleType == 2) {
                    sRatio = Math.max(xRatio, yRatio);
                }
            }
            domContainers[0].width = w * pRatio * sRatio;
            domContainers[0].height = h * pRatio * sRatio;
            domContainers.forEach((container) => {
                container.style.width = `${w * sRatio}px`;
                container.style.height = `${h * sRatio}px`;
            });
            stage.scaleX = pRatio * sRatio;
            stage.scaleY = pRatio * sRatio;
            lastW = iw; lastH = ih; lastS = sRatio;
            stage.tickOnUpdate = false;
            stage.update();
            stage.tickOnUpdate = true;
        }
    };
    an.handleSoundStreamOnTick = function (event) {
        if (!event.paused) {
            const stageChild = stage.getChildAt(0);

            if (!stageChild.paused || stageChild.ignorePause) {
                stageChild.syncStreamSounds();
            }
        }
    };
    an.handleFilterCache = function (event) {
        if (!event.paused) {
            const { target } = event;

            if (target) {
                if (target.filterCacheList) {
                    for (let index = 0; index < target.filterCacheList.length; index++) {
                        const cacheInst = target.filterCacheList[index];

                        if ((cacheInst.startFrame <= target.currentFrame) && (target.currentFrame <= cacheInst.endFrame)) {
                            cacheInst.instance.cache(cacheInst.x, cacheInst.y, cacheInst.w, cacheInst.h);
                        }
                    }
                }
            }
        }
    };

}(createjs, AdobeAn = AdobeAn || {}));

export { AdobeAn };
